<template>
    <el-main>
        <div class="search">
            <el-form :inline="true" :model="query" class="demo-form-inline">
                <el-form-item>
                    <el-button-group>
                        <el-button type="success" @click="$refs.batchAppend.showDialog('')"> 批量添加</el-button>
                        <el-button type="danger" @click="$refs.editForm.showDrawer('')"> 添加</el-button>
                    </el-button-group>
                </el-form-item>
                <div class="popover-datail">
                    <el-select v-model="query.company_id" placeholder="品牌名称" filterable clearable>
                        <el-option v-for="(item, index) in companyList" :key="index" :label="item.title" :value="item.id"></el-option>
                    </el-select>
                </div>
                <div class="popover-datail">
                    <el-select v-model="query.promoter_platform_id" placeholder="平台名称" filterable clearable>
                        <el-option v-for="(item, index) in platformList" :key="index" :label="item.title" :value="item.id"></el-option>
                    </el-select>
                </div>
                <div class="popover-datail">
                    <el-select v-model="query.promoter_store_id" placeholder="门店名称" filterable clearable>
                        <el-option v-for="(item, index) in storeList" :key="index" :label="item.title" :value="item.id"></el-option>
                    </el-select>
                </div>
                <div class="popover-datail">
                    <el-date-picker
                        v-model="query.cost_date"
                         value-format="yyyy-MM-dd"
                        type="daterange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                    >
                    </el-date-picker>
                </div>
                <el-form-item>
                    <el-button type="primary" @click="doSearch">查询</el-button>
                </el-form-item>
            </el-form>
        </div>
        <el-table :data="tableData" style="width: 100%" v-loading="loading">
            <el-table-column prop="id" label="编号" width="100"> </el-table-column>
            <el-table-column prop="company" label="品牌"> </el-table-column>
            <el-table-column prop="platform.title" label="平台名称"> </el-table-column>
            <el-table-column prop="store.title" label="店铺名称"> </el-table-column>
            <el-table-column prop="cost" label="花费"> </el-table-column>
            <el-table-column prop="cost_date" label="花费日期"> </el-table-column>
            <el-table-column label="操作" width="260">
                <template slot-scope="scope">
                    <el-button-group>
                        <el-button @click="$refs.editForm.showDrawer(scope.row)" type="primary" size="mini">编辑</el-button>
                        <el-button @click="deleteFn(scope.$index, scope.row)" type="danger" size="mini">删除</el-button>
                    </el-button-group>
                </template>
            </el-table-column>
        </el-table>

        <batchAppend ref="batchAppend" v-on:getTableData="getTableData" :companyList="companyList" :platformList="platformList" :storeList="storeList"></batchAppend>
        <editForm ref="editForm" v-on:getTableData="getTableData" :companyList="companyList" :platformList="platformList" :storeList="storeList"></editForm>
        <div class="fixed-bottom">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="pagination.page"
                :page-sizes="[15, 20, 30, 50]"
                :page-size="pagination.limit"
                layout="total, sizes, prev, pager, next, jumper"
                :total="pagination.total"
            >
            </el-pagination>
        </div>
    </el-main>
</template>

<script>
// import { delete } from 'vue/types/umd';
import batchAppend from './batchAppend';
import editForm from './edit';
export default {
    components: {
        batchAppend,
        editForm
    },
    data() {
        return {
            loading: false,

            name: 'Parent',
            query: {
                id: '', //平台编号
                company_id: '', //品牌名称
                promoter_platform_id: '', //平台名称
                promoter_store_id: '', //门店名称
                cost_date: '' //时间
            },
            tableData: [],
            pagination: {
                page: 1,
                limit: 30,
                total: 0
            },
            storeList: [],
            platformList: [],
            companyList: []
        };
    },
    created() {
        this.getTableData();
        this.getPickerData();
    },
    methods: {
        getTableData() {
            //获取表格列表
            let that = this;
            let url = '/api/promoter.cost/index';
            let query = this.query;
            query.pagination = this.pagination;
            that.loading = true;
            this.$post(url, query).then(function (response) {
                let result = response.data;
                that.tableData = result.list;
                that.pagination = result.pagination;
                that.loading = false;
            });
        },
        doSearch() {
            // 搜索
            this.pagination={
                page: 1,
                limit: 30,
                total: 0
            },
            this.getTableData();
        },
        handleSizeChange(val) {
            this.pagination.limit = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.pagination.page = val;
            this.getTableData();
        },
        getPickerData() {
            let that = this;
            let url = '/api/promoter.cost/picker';
            this.$post(url).then(function (response) {
                if (response.code == '200') {
                    that.storeList = response.data.storeList;
                    that.platformList = response.data.platformList;
                    that.companyList = response.data.companyList;
                } else {
                    this.$message(response.msg);
                }
            });
        },
        deleteFn(index, e) {
            let _this = this;
            this.$confirm('此操作将, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(() => {
                    let url = '/api/promoter.cost/delete';
                    let query = { id: e.id };
                    _this.loading = true;
                    this.$post(url, query).then(function (response) {
                        if (response.code == 200) {
                            _this.tableData.splice(index, 1);
                        }
                        _this.$message({
                            type: 'success',
                            message: response.msg
                        });
                        _this.loading = false
                    });
                })
                .catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消'
                    });
                });
        }
    }
};
</script>
<style scoped>
.popover-datail {
    display: inline-block;
    margin-right: 10px;
}
</style>
